export default {
  options: {
    true: 'Sim',
    false: 'Não',
  },
};
